module.exports = __webpack_public_path__ + "img/Bahrain.bd925c29.svg";